import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
`;

export const Container = styled.div`
  margin: 10rem auto;
  width: 50rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5rem;
  font-size: 1.6rem;

  & > input {
    display: none;
  }

  & > img {
    max-width: 50rem;
  }
`;

export const UploadBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  border: 1px solid black;
  text-align: center;
  border-radius: 1rem;
  padding: 2rem 1rem;

  &:hover {
    color: white;
    background-color: black;
    cursor: pointer;
  }
`;

export const UploadLabel = styled.label`
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  border: 1px solid black;
  border-radius: 1rem;

  &:hover {
    color: white;
    background-color: black;
    cursor: pointer;
  }
`;
